import { GtmhubController } from "@gtmhub/core";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { CurrentUserService } from "@gtmhub/users";
import { IComponentOptions, IScope } from "angular";

export enum HomeScreenViewValuesEnum {
  dashboard = "dashboard",
  feed = "feed",
}

export class HomeScreenCtrl extends GtmhubController {
  active: HomeScreenViewValuesEnum;
  static $inject = ["$scope", "$rootScope", "CurrentUserService"];

  constructor(private $scope: IScope, private $rootScope: ITraceRootScopeService, private currentUserService: CurrentUserService) {
    super();
  }

  $onInit(): void {
    this.active = this.currentUserService.getUserSetting("homeScreen") || HomeScreenViewValuesEnum.dashboard;

    this.$scope.$on("toggleChangeTab", (e, tab): void => {
      this.changeTab(tab);
    });
  }

  changeTab = (tab: HomeScreenViewValuesEnum) => {
    this.active = tab;
    this.currentUserService.setUserSetting({ homeScreen: this.active });
    this.$rootScope.$broadcast("homeScreenChanged");
  };
}

export const HomeScreenComponent: IComponentOptions = {
  controller: HomeScreenCtrl,
  templateUrl: require("./home-screen.jade"),
};
